import { useCallback } from "react";

import { Overflow, OverflowItem, Tab, TabList } from "@fluentui/react-components";
import { useAtom } from "jotai";
import { devices } from "library/constants";
import { EProfileTab, ITabProps } from "library/types";
import { useTranslation } from "react-i18next";
import { selectedProfileTabAtom } from "store/UIProfilePage";
import styled from "styled-components";

import { OverflowMenuComponent } from "components/OverflowMenuComponent/OverflowMenuComponent";
import { useHasGivenConsent } from "hooks/useHasGivenConsent";
import { useIsMobile } from "hooks/useIsMobile";

const tabs: ITabProps[] = [
  {
    id: EProfileTab.info,
    name: "hbh.userDetails.label",
    // icon: <InfoRegular />,
  },
  {
    id: EProfileTab.consents,
    name: "hbh.consents.label",
    // icon: <DocumentSettingsRegular />,
  },
  {
    id: EProfileTab.documents,
    name: "hbh.documents.label",
    // icon: <DocumentSettingsRegular />,
  },
  {
    id: EProfileTab.dependents,
    name: "hbh.dependents.label",
    // icon: <PeopleRegular />,
  },
];

export function ProfilePageContentSelect() {
  const { t } = useTranslation();

  const isMobile = useIsMobile();
  const hasGivenConsent = useHasGivenConsent();

  const [selectedTab, setSelectedTab] = useAtom(selectedProfileTabAtom);

  const onSelectTab = useCallback((tab) => {
    setSelectedTab(tab);
  }, []);

  return (
    <Container>
      <Overflow minimumVisible={isMobile ? 3 : 7}>
        <StyledTabList
          selectedValue={selectedTab}
          onTabSelect={(_, d) => onSelectTab(d.value as EProfileTab)}
        >
          {tabs.map((tab) => {
            return (
              <OverflowItem key={tab.id} id={tab.id} priority={tab.id === selectedTab ? 2 : 1}>
                <StyledTab
                  value={tab.id}
                  icon={tab.icon ? <span>{tab?.icon}</span> : null}
                  disabled={!hasGivenConsent}
                >
                  {t(tab.name)}
                </StyledTab>
              </OverflowItem>
            );
          })}
          <OverflowMenuComponent tabs={tabs} onTabSelect={onSelectTab} />
        </StyledTabList>
      </Overflow>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  position: sticky;
  top: 0;
  background: ${(props) => props.theme.palette.themeBackground};
  z-index: 9999;
`;

const StyledTabList = styled(TabList)`
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutralLight};
  @media only screen and ${devices.md} {
    gap: 20px;
  }
`;
const StyledTab = styled(Tab)`
  @media only screen and ${devices.md} {
    padding: 10px 15px;
  }
`;
